import {
  domainSolvingLegal,
  email,
  Firma,
  getFirmaDisplayName,
  phone,
} from "@/lib/consts";
import { defaultLocale } from "@/lib/i18n/locales";
import { getMessages } from "@/lib/i18n/messages";
import { LocationEnum } from "@/lib/locationEnum";
import { locationStrings } from "@/lib/strings/locationStrings";
import {
  ContactPoint,
  OpeningHoursSpecification,
  Organization,
} from "schema-dts";

const openingHoursSpecification: OpeningHoursSpecification = {
  "@type": "OpeningHoursSpecification",
  dayOfWeek: [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ],
  opens: "08:00",
  closes: "20:00",
  validFrom: "2023-01-01",
};

const contactPoint: ContactPoint = {
  "@type": "ContactPoint",
  contactType: "Kundenservice",

  availableLanguage: "de, en",
  areaServed: "DE, AT, CH",
  hoursAvailable: openingHoursSpecification,
  productSupported: "Resolvio Beschlussplattform, Resolvio App",
  url: "https://resolvio.com",
};

const contactPointSolvingLegal: ContactPoint = {
  "@type": "ContactPoint",
  contactType: "Rechtsberatung",
  telephone: phone.general,
  email: email.general,
  availableLanguage: "de, en",
  areaServed: "DE, AT, CH",
  hoursAvailable: openingHoursSpecification,
  productSupported:
    "Rechtsberatung im Unternehmensrecht, inbesondere Gesellschaftsrecht, Steuerberatung, Arbeitsrecht, Erbrecht und Unternehmensnachfolge",
  url: domainSolvingLegal,
};

enum RVOOrganisations {
  ResolvioGmbH = "ResolvioGmbH",
  SolvingLegal = "SolvingLegal",
}

const solvingLegalLegalName = getFirmaDisplayName(
  defaultLocale,
  Firma.SolvingLegal,
);
const solvingLegalSlogan =
  getMessages(defaultLocale).common.brand.sloganSolvingLegal;

export const schemaOrgOrganizations: Record<RVOOrganisations, Organization> = {
  ResolvioGmbH: {
    "@type": "Organization",
    name: "Resolvio GmbH",
    brand: "Resolvio",
    contactPoint: contactPoint,
    foundingDate: "2021",
    foundingLocation: "Mainz, Deutschland",
    knowsAbout:
      "Digitale Beschlussfasung, Digitale Beschlüsse, Digitale Umlaufbeschlüsse, digitale Sitzungen, digitale Gesellschafterversammlungen, digitale Hauptversammlungen, digitale Versammlungen, digitale Abstimmungen, digitale Beschlussplattform, digitale Plattform für Gesellschafterversammlungen, digitale Plattform für Hauptversammlungen, digitale Plattform für Versammlungen, digitale Plattform für Abstimmungen",
    knowsLanguage: "de, en",
    legalName: "Resolvio GmbH",
    location: "Heilbronn, Germany",
    address: {
      "@type": "PostalAddress",
      addressLocality: "Heilbronn, Germany",
      postalCode: "DE-74076",
      streetAddress: "c/o Campus Founders, Bildungscampus 1",
    },
    logo: "https://cms.resolvio.de/wp-content/uploads/2025/01/Design-ohne-Titel-4.png",

    vatID: "DE349837190",
    url: "https://resolvio.com",
    sameAs: [
      "https://www.linkedin.com/company/81423429",
      "https://www.youtube.com/@Resolvio",
      "https://www.instagram.com/resolvio_official",
    ],
  },
  SolvingLegal: {
    "@type": "Organization",
    name: solvingLegalLegalName,
    brand: "Solving Legal",
    contactPoint: contactPointSolvingLegal,
    email: "info@solving.legal",
    foundingDate: "2025",
    slogan: solvingLegalSlogan,
    foundingLocation: "Stuttgart, Deutschland",
    knowsAbout:
      "Gesellschaftsrecht, Mitarbeiterbeteiligung, Steuerrecht, Rechtsprechung",
    knowsLanguage: "de, en",
    legalName: solvingLegalLegalName,
    location: {
      "@type": "Place",
      address: {
        "@type": "PostalAddress",
        streetAddress: `${locationStrings[LocationEnum.Koblenz].street} ${locationStrings[LocationEnum.Koblenz].houseNumber}`,
        addressLocality: locationStrings[LocationEnum.Koblenz].city,
        postalCode: locationStrings[LocationEnum.Koblenz].postalCode,
        addressCountry: "DE",
      },
    },
    address: {
      "@type": "PostalAddress",
      streetAddress: `${locationStrings[LocationEnum.Koblenz].street} ${locationStrings[LocationEnum.Koblenz].houseNumber}`,
      addressLocality: locationStrings[LocationEnum.Koblenz].city,
      postalCode: locationStrings[LocationEnum.Koblenz].postalCode,
      addressCountry: "DE",
    },
    telephone: phone.general,
    url: domainSolvingLegal,
  },
};
